(function($) {
  $('#tab-container').easytabs({
    animate: false,
    // animationSpeed: 'fast',
  });
})($);